import type { FC, ReactNode } from "react";

import { Container } from "@aviary";

import * as styles from "./OpenNavigationContainer.styles";

interface Props {
  children: ReactNode;
}

const OpenNavigationContainer: FC<Props> = ({ children }) => {
  return (
    <div css={styles.mainNav}>
      <Container css={styles.container}>{children}</Container>
    </div>
  );
};

export { OpenNavigationContainer };
